import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import {
  getInputField,
  getSelectField,
  getPasswordInputField,
  getDNIField
} from '../subscriptor/forms/fields';
import { maintainerForm as styles } from '../maintainer/styles';
import {
  USER_MAX_LENGTH_NAME,
  USER_MAX_LENGTH_LASTNAME,
  USER_MAX_LENGTH_PASSWORD,
  USER_MIN_LENGTH_PASSWORD,
  USER_MAX_LENGTH_EMAIL,
  ROLE_LIST
} from '../../libraries/constants';

import { INCORRECT_MINIMUM_CHARACTERS_PASSWORD } from '../../libraries/texts';
import { maximumSubString } from '../../libraries/utils';

const form = props => {
  const {
    values,
    classes,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    setFieldTouched,
    title
  } = props;
  const {
    match: {
      params: { id }
    }
  } = props;

  const fieldProps = {
    handleBlur,
    classes,
    touched,
    errors,
    values,
    setFieldValue,
    setFieldTouched
  };

  useEffect(() => {
    if (id && typeof values.role === 'string') {
      const role = ROLE_LIST.filter(({ name, code }) => code === values.role);
      if (role && role.length > 0) {
        setFieldValue('role', role[0]);
      }
    }
  }, [values.role]);

  return (
    <Card className={classes.card}>
      <CardHeader title={title} className={classes.cardTitle} />
      <CardContent className={classes.cardContent}>
        {values ? (
          <React.Fragment>
            {getInputField({
              ...fieldProps,
              name: `name`,
              label: 'Nombre',
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_NAME),
              formControlClass: classes.middleWidth
            })}
            {getInputField({
              ...fieldProps,
              name: `lastName`,
              label: 'Apellido',
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_LASTNAME),
              formControlClass: classes.middleWidth
            })}
            {getDNIField({
              ...fieldProps,
              name: `rut`,
              label: 'Rut',
              required: true,
              formControlClass: classes.middleWidth
            })}
            {getInputField({
              ...fieldProps,
              name: `username`,
              label: 'Email',
              required: true,
              changeHandler: maximumSubString(USER_MAX_LENGTH_EMAIL),
              formControlClass: classes.middleWidth
            })}

            {getSelectField({
              ...fieldProps,
              name: `role`,
              label: 'Rol *',
              optionValue: value => value.code,
              onMenuClose: () => {
                setFieldTouched('role');
              },
              required: true,
              options: ROLE_LIST,
              formControlClass: classes.fullWidth
            })}
            {getPasswordInputField({
              ...fieldProps,
              name: `password`,
              label: 'Contraseña',
              prefixLabel: !id ? '' : 'Nueva ',
              placeholder: INCORRECT_MINIMUM_CHARACTERS_PASSWORD(USER_MIN_LENGTH_PASSWORD),
              required: !id ? true : values.password || values.confirmPassword ? true : false,
              changeHandler: maximumSubString(USER_MAX_LENGTH_PASSWORD),
              formControlClass: classes.middleWidth
            })}
          </React.Fragment>
        ) : (
          ''
        )}
      </CardContent>
    </Card>
  );
};

form.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(form);
